// extracted by mini-css-extract-plugin
module.exports = {"canvasWrap":"config_canvasWrap_3FSDF"};